import { Badge, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loader from '../components/Loader';
import { useGetNewsPostsQuery } from '../slices/newsApiSlice';

const NewsListScreen = () => {
  const { data: posts, isLoading, error } = useGetNewsPostsQuery();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="section-modern">
      <Container className="fade-in py-5">
        <div className="mb-5">
          <h1 className="text-primary mb-3">League Runner News</h1>
          <p className="lead text-secondary mb-0">
            League events, community stories, announcements, and big moments from the League Runner crew.
          </p>
        </div>

        {error ? (
          <Card className="modern-card">
            <Card.Body className="text-danger">
              {error?.data?.message || 'Unable to load news right now.'}
            </Card.Body>
          </Card>
        ) : posts?.length ? (
          <Row className="g-4">
            {posts.map((post) => (
              <Col key={post._id} lg={6}>
                <Card className="modern-card h-100">
                  {post.imageUrl ? (
                    <Link to={`/news/${post.slug}`}>
                      <Card.Img
                        variant="top"
                        src={post.imageUrl}
                        alt={post.imageAlt || post.title}
                        style={{ aspectRatio: '16 / 9', objectFit: 'cover' }}
                      />
                    </Link>
                  ) : null}
                  <Card.Body className="d-flex flex-column">
                    <div className="text-secondary small mb-2">
                      {post.publishedAt
                        ? new Date(post.publishedAt).toLocaleDateString()
                        : 'Unpublished'}
                    </div>
                    <Card.Title as="h2" className="h4">
                      <Link to={`/news/${post.slug}`} className="text-decoration-none">
                        {post.title}
                      </Link>
                    </Card.Title>
                    <Card.Text className="text-secondary">{post.summary}</Card.Text>
                    <div className="d-flex flex-wrap gap-2 mt-auto mb-3">
                      {post.tags?.map((tag) => (
                        <Badge bg="light" text="dark" key={tag}>
                          {tag}
                        </Badge>
                      ))}
                    </div>
                    <Link to={`/news/${post.slug}`} className="btn btn-outline-primary align-self-start">
                      Read story
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <Card className="modern-card">
            <Card.Body className="text-secondary">
              No published stories yet. The first league announcement will land here.
            </Card.Body>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default NewsListScreen;
